"use client";

import { clsx } from "clsx";

import { iconStrokeFix } from "@ui/central-icons/iconUtils";
import IconChevronLeftMedium from "@ui/central-icons/icons/IconChevronLeftMedium";
import IconChevronRightMedium from "@ui/central-icons/icons/IconChevronRightMedium";

export function MediaListPagination({
  currentPage,
  nextLabel,
  onNext,
  onPrevious,
  previousLabel,
  totalPages,
}: {
  currentPage: number;
  nextLabel: string;
  onNext: () => void;
  onPrevious: () => void;
  previousLabel: string;
  totalPages: number;
}) {
  return (
    <div className='tw-flex tw-w-full tw-items-center tw-justify-between tw-pl-2.5 tw-pr-3'>
      <div className='tw-flex tw-gap-2'>
        <button
          type='button'
          className='tw-flex tw-size-8 tw-items-center tw-justify-center tw-rounded-full tw-bg-white tw-text-black tw-shadow-[0_0_1px_0_rgba(0,0,0,0.4),0_1px_1px_0_rgba(0,0,0,0.04),0_2px_4px_0_rgba(0,0,0,0.04)] tw-outline-none tw-transition-opacity disabled:tw-cursor-not-allowed disabled:tw-opacity-40 focus-visible:tw-outline-focus'
          onClick={onPrevious}
          disabled={currentPage === 0}
          aria-label={previousLabel}
        >
          <IconChevronLeftMedium className={clsx(iconStrokeFix, "tw-size-3.5")} />
        </button>
        <button
          type='button'
          className='tw-flex tw-size-8 tw-items-center tw-justify-center tw-rounded-full tw-bg-white tw-text-black tw-shadow-[0_0_1px_0_rgba(0,0,0,0.4),0_1px_1px_0_rgba(0,0,0,0.04),0_2px_4px_0_rgba(0,0,0,0.04)] tw-outline-none tw-transition-opacity disabled:tw-cursor-not-allowed disabled:tw-opacity-40 focus-visible:tw-outline-focus'
          onClick={onNext}
          disabled={currentPage >= totalPages - 1}
          aria-label={nextLabel}
        >
          <IconChevronRightMedium className={clsx(iconStrokeFix, "tw-size-3.5")} />
        </button>
      </div>
      <p aria-live='polite' className='tw-type-sm tw-tabular-nums tw-text-black/60'>
        {currentPage + 1}/{totalPages}
      </p>
    </div>
  );
}
